(function(){
    if(typeof APPS === 'undefined'){ APPS = {}; }
    APPS.landingPages = {};
    
    /*================================================================================
		Router
	 ================================================================================*/
    var Router = Marionette.AppRouter.extend({
        appRoutes:{
             "digital" 		         : "showLandingPage_Digital",
             "request"		         : "showLandingPage_request",
             "request_confirmation"	 : "showLandingPage_confirmation",
             "calendar"		         : "showLandingPage_calendar",
             "calendar_confirmation" : "showLandingPage_calendar_confirmation",
             "open_mic_registration" : "showLandingPage_open_mic_registration",
             "open_mic_registration_confirmation" : "showLandingPage_open_mic_registration_confirmation"
        }
    })
    
    /*================================================================================
		Api - called by the Router and through Radio events
	 ================================================================================*/
    var API = {
        showLandingPage_Digital:function(){
            APPS.landingPages.digital.show();
        },
        showLandingPage_request:function(){
	        APPS.landingPages.request.show();
        },
        showLandingPage_confirmation:function(option){
	        var param = {};
	        if(option){
		        param.status = true;
	        } else {
		        param.status = false;
	        };
	        
	        if(param.status){
		      APPS.landingPages.confirmation.show();  
	        }
	        
        },
        showLandingPage_calendar:function(){
	        APPS.landingPages.calendar.show();
        },
        showLandingPage_calendar_confirmation:function(option){
	        var param = {};
	        if(option){
		        param.status = true;
	        } else {
		        param.status = false;
	        };
	        
	        if(param.status){
		      APPS.landingPages.calendarConfirmation.show();  
	        }
	        
        },
        showLandingPage_open_mic_registration:function(){
            APPS.landingPages.open_mic_registration.show();
        },
        showLandingPage_open_mic_registration_confirmation:function(){
            APPS.landingPages.open_mic_registration_confirmation.show();
        },        
    }
    
     /*================================================================================
		Event Handlers
	 ================================================================================*/
    Backbone.Radio.channel('request').reply("confirmation",function(param){
        Backbone.history.navigate('/request_confirmation')
        API.showLandingPage_confirmation(param); 
    })
    
    Backbone.Radio.channel('calendar').reply("confirmation",function(param){
        Backbone.history.navigate('/calendar_confirmation')
        API.showLandingPage_calendar_confirmation(param); 
    })

    Backbone.Radio.channel('open_mic_registration').reply("open_mic_registration_confirmation",function(param){
        Backbone.history.navigate('/open_mic_registration_confirmation')
        API.showLandingPage_open_mic_registration_confirmation(param); 
    })
    
    APP.on("before:start",function(){
		new Router({
			controller: API
		})
	})
})();